<template>
	<div class="input__container">
		<span v-if="label != ''" class="input__label-text">
			{{ label }}
			<span v-if="mandatory" class="input__mandatory">*</span>
		</span>
		<label
			class="input__label"
			:class="[
				{ 'input__label--disabled': isDisabled },
				{ 'input--accepted': accepted },
				{ 'input__label--icon-right': iconPlacement === 'right' },
				{ 'input__label--loading': isLoading },
				{ 'input--valid': isValid }
			]"
		>
			<slot></slot>
			<input
				:type="type"
				:class="[
					'formtext',
					'input',
					lightTheme ? 'input--lightTheme' : '',
					productMandatory ? 'input--mandatory' : '',
					hasError ? 'input--error' : ''
				]"
				:placeholder="placeholderValue"
				:autocomplete="autocomplete"
				v-bind:value="value ? value : defaultValue"
				v-on:input="$emit('input', $event.target.value)"
				v-on:click="$emit('input-enter', $event.target.value)"
				:disabled="isDisabled"
				@focus="$emit('fucus-input', true)"
				@blur="$emit('fucus-input', false)"
			/>
			<svg data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-if="icon != '' && iconPlacement === 'right' && !isLoading" v-bind:svg-inline="''" v-bind:class="'icon'" v-bind:focusable="'false'" v-bind:role="'presentation'" v-bind:tabindex="'-1'"><path d="M22 2H2a1 1 0 00-1 1v18a1 1 0 001 1h20a1 1 0 001-1V3a1 1 0 00-1-1zM6.75 20H3v-3h3.75zm0-4H3v-3h3.75zm0-4H3V9h3.75zm4.75 8H7.75v-3h3.75zm0-4H7.75v-3h3.75zm0-4H7.75V9h3.75zm4.75 8H12.5v-3h3.75zm0-4H12.5v-3h3.75zm0-4H12.5V9h3.75zM21 20h-3.75v-3H21zm0-4h-3.75v-3H21zm0-4h-3.75V9H21zm0-5H3V4h18z"/></svg>
			<Loading v-if="isLoading" :dark="true" />
			<!--:src="'../../assets/icons/' + icon"-->
		</label>
		<span
			:class="[
				'input__error',
				{ 'input__error--red': redErrorColor },
				whiteErrorColor && lightTheme ? 'input__error--white' : ''
			]"
			v-if="errorMessage != ''"
		>
			{{ errorMessage }}
		</span>
	</div>
</template>

<script>
import Loading from './Loading'

export default {
	name: 'InputComponent',
	components: {
		Loading
	},
	props: {
		type: {
			type: String,
			default: 'text'
		},
		autocomplete: {
			type: String,
			default: 'text'
		},
		mandatory: {
			type: Boolean,
			default: false
		},
		productMandatory: {
			type: Boolean,
			default: false
		},
		placeholderValue: {
			type: String,
			default: ''
		},
		addclass: {
			type: String,
			default: ''
		},
		errorMessage: {
			type: String,
			default: ''
		},
		accepted: {
			type: Boolean,
			default: false
		},
		isDisabled: {
			type: Boolean,
			default: false
		},
		hasError: {
			type: Boolean,
			default: false
		},
		isValid: {
			type: Boolean,
			default: false
		},
		redErrorColor: {
			type: Boolean,
			default: false
		},
		whiteErrorColor: {
			type: Boolean,
			default: false
		},
		lightTheme: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		value: {
			type: String,
			default: ''
		},
		defaultValue: {
			type: String,
			default: ''
		},
		icon: {
			type: String,
			default: ''
		},
		iconPlacement: {
			type: String,
			default: 'left'
		},
		isLoading: {
			type: Boolean,
			default: false
		}
	}
}
</script>

<style scoped lang="scss">
.input__container {
	text-align: left;
}
.input__label {
	display: flex;
	// flex-wrap: wrap;
	position: relative;
	width: 100%;
	&--disabled {
		opacity: 0.5;
		pointer-events: none;
	}
	svg {
		fill: $colorPrimary6;
		width: 24px;
		height: 24px;
		background: $colorInputBorder;
		padding: 8px;
		border-radius: 5px 0px 0px 5px;
		box-sizing: content-box;
	}
	svg + .input {
		border: 0;
		border-radius: 0px 5px 5px 0px;
	}
	&--icon-right {
		.input {
			border-radius: 5px 0 0 5px;
			border-right: 0;
		}
		.icon {
			fill: $colorPrimary8;
			background: #ffffff;
			border: 1px solid #bfc5cf;
			border-radius: 0px 5px 5px 0px;
			border-left: 0;
			padding: 12px 13px;
			margin-left: -1px;
			@include for-tablet-portrait-up {
				padding: 7px 13px;
			}
		}
	}
	&-text {
		display: block;
		color: #697791;
		font-family: Saira;
		font-size: 15px;
		line-height: 24px;
		margin-bottom: 5px;
	}

	> button.btn--small {
		height: 40px;
		order: 2;
		margin-left: 10px;
		padding: 17px 18px;
		@include for-tablet-portrait-up {
			height: 40px;
			padding: 12px 13px;
		}
	}

	&--loading {
		.input {
			border-radius: 5px 0 0 5px;
			border-right: 0;
		}
		.Loading-wrapper {
			fill: $colorPrimary8;
			background: #ffffff;
			border: 1px solid #bfc5cf;
			border-radius: 0px 5px 5px 0px;
			border-left: 0;
			padding: 12px 13px;
			margin-left: -1px;
			@include for-tablet-portrait-up {
				padding: 7px 13px;
			}
		}
	}
}
.input__error {
	position: absolute;
	color: $colorRed;
	display: inline-block;
	font-size: 10px;
	line-height: 15px;
	margin-top: 10px;
	&--red {
		color: #e15b5b;
	}
	&--white {
		color: #fff;
	}
}
.input {
	//@extend .formtext;
	width: 100%;
	box-sizing: border-box;
	outline: 0;
	background: $colorInputBackground;
	box-shadow: inset 0 0 1px 0 rgba(0, 0, 0, 0.2);
	border: 0;
	border-radius: 5px;

	height: 40px;
	@include for-tablet-portrait-up {
		height: 40px;
		font-size: 16px;
		&.formtext {
			font-size: 16px;
		}
	}

	color: $colorInputText;
	padding-left: 12px;
	&::-ms-clear {
		display: none;
	}

	&::placeholder {
		font-weight: 300;
		color: #7f8ba1;
	}

	&__mandatory {
		font-size: 15px;
		color: $colorRed;
		margin-left: -3px;
	}

	&--lightTheme {
		background: $colorWhite;
		border: 1px solid $colorPrimary3;
	}

	&--error {
		color: $colorWhite;
		background: $colorRed;
	}
	&--error::placeholder {
		color: $colorWhite;
	}

	&--valid {
		border: 1px solid $colorGreen;
		position: relative;
		&::after {
			content: '';
			position: absolute;
			right: 10px;
			top: 10px;
			width: 20px;
			height: 20px;
			border-radius: 10px;
			background-color: $colorGreen;
			background-size: 12px;
			background-image: url('https://boka.klappen.se/checkbox_k_ico_12x12.svg');
			background-repeat: no-repeat;
			background-position: 4px;
		}
	}

	&--accepted {
		&::after {
			content: '';
			position: absolute;
			right: 16px;
			top: 16px;
			width: 20px;
			height: 20px;
			background-size: 18px;
			background-image: url('https://boka.klappen.se/checkbox_k_ico_12x12-grey.svg');
			background-repeat: no-repeat;
		}
	}
	&--mandatory {
		border: 2px solid #64c7bc;
	}

	+ button {
		position: absolute;
		right: 10px;
		top: 15px;
		border: 0;
		height: 20px;
		width: 20px;
		padding: 2px 0 0px 0;
		border-radius: 20px;
		color: $colorWhite;
		background: rgba(93, 93, 93, 0.25);
		outline: 0;
		cursor: pointer;
		.btn--reset {
			color: $colorWhite;
			fill: $colorWhite;
			height: 14px;
			width: 14px;
		}
	}
}

.accordion {
	.input__container {
		padding-top: 5px;
		padding-bottom: 20px;
	}

	.booking-modal-container {
		.input__container {
			/*padding-top: 0;
			padding-bottom: 0;*/
			padding-top: 5px;
			padding-bottom: 20px;
		}
	}

	p.h4 {
		margin-bottom: 0 !important;
	}
}

.accordion-fieldset,
.booking-modal-container .accordion-fieldset {
	.input__error {
		margin-top: 2px;
		position: relative;
	}
	.input--mandatory {
		border: 1px solid #bfc5cf;
	}
}
</style>
